const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M5.376 0.192q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.856 1.056-3.584t2.336-3.936 1.6-4.96q0.064-0.128 0.224-0.128t0.16 0.128zM25.088 0.192q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.536 0.672-2.976t1.536-2.496 1.696-2.944 1.088-4.064q0.064-0.128 0.224-0.128t0.16 0.128zM14.848 14.4q0.064-0.128 0.224-0.128t0.16 0.128q0.32 2.752 1.6 4.96t2.336 3.936 1.056 3.584q0 2.112-1.536 3.616t-3.648 1.504-3.648-1.504-1.536-3.616q0-1.856 1.056-3.584t2.336-3.936 1.6-4.96z"
});

const SvgWater = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-water",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water.70e41f12.svg";
export { ForwardRef as ReactComponent };